import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

// Create a single Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Extend window object to include Clerk
declare global {
  interface Window {
    Clerk?: {
      session?: {
        getToken(): Promise<string | null>;
      };
    };
  }
}

// Function to make authenticated requests to Supabase
export const makeAuthenticatedRequest = async (endpoint: string, options: RequestInit = {}) => {
  try {
    console.log('Making authenticated request to:', endpoint);
    
    // Check if Clerk is available
    if (!window.Clerk) {
      console.warn('Clerk not available, making unauthenticated request');
    }
    
    let clerkToken = null;
    try {
      clerkToken = await getClerkTokenForSupabase();
      console.log('Clerk token retrieved:', clerkToken ? 'Yes' : 'No');
    } catch (tokenError) {
      console.error('Error getting Clerk token:', tokenError);
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'apikey': supabaseAnonKey,
      ...(clerkToken && { 'Authorization': `Bearer ${clerkToken}` }),
      ...options.headers
    };

    console.log('Request headers:', headers);

    const response = await fetch(`${supabaseUrl}/rest/v1/${endpoint}`, {
      ...options,
      headers
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Response error:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.json();
    console.log('Response data:', data);
    return data;
  } catch (error) {
    console.error('Error making authenticated request:', error);
    throw error;
  }
};

// Function to get Clerk token with Supabase template (for use in components)
export const getClerkTokenForSupabase = async (): Promise<string | null> => {
  try {
    // Try to get token from global storage (set by SupabaseAuthProvider)
    const globalToken = (window as any).__clerkSupabaseToken;
    console.log('Global token available:', globalToken ? 'Yes' : 'No');
    if (globalToken) {
      console.log('Using global Supabase token');
      return globalToken;
    }
    
    // Fallback: try to get token from Clerk auth hook if available
    if (window.Clerk?.session) {
      return await window.Clerk.session.getToken();
    }
    
    return null;
  } catch (error) {
    console.error('Error getting Clerk token for Supabase:', error);
    return null;
  }
}; 